import React from 'react';
import Box from '@mui/material/Box';
import moment from 'moment';
import { Link } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';



const pageSizeOptions = [10, 15, 30, 50]; // Define available page sizes


const SearchResult = ({searchResult, orgId, showLOB, lob, service_date}) => {

  const columns = [
      { field: 'id', headerName: 'ID', width: 90, flex: 1 },
      { 
        field: 'policyID', 
        headerName: 'Policy #', 
        width: 90, 
        flex: 1,
      },
      {
        field: 'policyName',
        headerName: 'Policy Name',
        editable: false,
        flex: 1,
      },
      {
        field: 'effectiveDates',
        headerName: 'Effective Dates',
        editable: false,
        type: 'date',
        valueGetter: (effectiveDate) => {
          if (!effectiveDate) return null;
          const [day, month, year] = effectiveDate.split('-');
          return new Date(`${year}-${month}-${day}`);
        },
        flex: 1,
      },
      {
        field: 'versionNumber',
        headerName: 'Version',
        editable: false,
        flex: 1,
        renderCell: (params) => {

          let urlParams = '';

          if (lob) {
            urlParams = '?lob=' + params['row'].lob
          }

          if (service_date) {
            urlParams = urlParams ? urlParams + '&service_date=' + service_date : '?service_date=' + service_date;
          }
          

          return (
            <Link to={`${process.env.REACT_APP_MYPOLICIES_URL}/policy/${orgId}/${params['row'].policyID}/${params['row'].versionID}${urlParams}`} target="_blank" rel="noopener noreferrer" >{params.value}</Link>
          )

        },
      },
      {
        field: 'status',
        headerName: 'Status',
        editable: false,
        flex: 1,
        renderCell: (params) => {
            return (params?.value && params?.value?.toUpperCase()==='REVIEW') ? 'Draft' : (params?.value && params?.value?.toUpperCase()==='PUBLISHED') ? 'Final' : params.value
        },
      },
      {
        field: 'lob',
        headerName: 'Line of Business',
        editable: false,
        flex: 1,
      },
  ];

    const [policyListing, setPolicyListing] = React.useState([]);
    const [paginationModel, setPaginationModel] = React.useState({ pageSize: 10, page: 0 });

    function getFormattedDateRange(effectivedate = "", inactivedate = "") {
      const formattedEffectiveDate = moment.utc(effectivedate).format("MM/DD/YYYY");
      const formattedInactiveDate = inactivedate
        ? ` - ${moment.utc(inactivedate).format("MM/DD/YYYY")}`
        : "";
      return `${formattedEffectiveDate}${formattedInactiveDate}`;
    }


    function capitalizeWords(str="") {
      if (!str || typeof str !== "string") return "";
      return str
        .toLowerCase()
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }
    
    
    React.useEffect(() => {
      

      let listing = searchResult ? searchResult.map((item, index) => {
        return {
          id: index,
          policyID: item?.policy_shortname,
          policyName: item?.policy,
          effectiveDates: getFormattedDateRange(item?.effectivedate, item?.inactivedate),
          versionNumber: item?.version,
          versionID: item?.version_id,
          status: capitalizeWords(item?.workflow),
          lob: item?.lob
        }
      })
      .sort((a, b) => {
        if (a.policyID < b.policyID) return -1;
        if (a.policyID > b.policyID) return 1;
        return 0;
      }) : [];

      setPolicyListing(listing)
      
    }, [searchResult]);

    return (<Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', marginBottom:'30px'}}>
        <DataGrid
          rows={policyListing}
          columns={columns}
          initialState={{
            columns: {
              columnVisibilityModel: {
                // Hide columns status and traderName, the other columns will remain visible
                id: false,
                lob: (showLOB ? true : false)
              },
            },        
            pagination: {
              paginationModel: {
                pageSize: paginationModel.pageSize,
              },
            },
          }}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
          }}
          pageSizeOptions={pageSizeOptions} // Provide multiple options
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel} 
          checkboxSelection={false}
          disableRowSelectionOnClick
          localeText={{ noRowsLabel: "No Results Found!" }}

        />
      </Box>)
}

export default SearchResult;